var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-jumbotron',{staticClass:"bg-light my-3",attrs:{"header":"Page d'erreur !","lead":"Vous n'avez pas les droits pour accéder à cette page.","header-level":"4","border-variant":"grey"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }